import { render, staticRenderFns } from "./SmsOriginatorRules.vue?vue&type=template&id=774aa960&"
import script from "./SmsOriginatorRules.vue?vue&type=script&lang=ts&"
export * from "./SmsOriginatorRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports